import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "nav nav-pills" }

import { computed } from 'vue'
    import { useRoute } from 'vue-router'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectNavigation',
  props: {
    ActivePage: {},
    workspaceId: {},
    tchProjectId: {},
    projectId: {},
    planId: {}
  },
  setup(__props: any) {

    const props = __props

    const route = useRoute()

    function nav(name: string)
    {
        return {
            name,
            params: {
                workspaceId: props.workspaceId,
                tchProjectId: props.tchProjectId,
                projectId: props.projectId,
                planId: props.planId ?? undefined
            },
            query: route.query
        }
    }

    const pages = computed(() => [
        {
            key: 'settings',
            label: 'Settings',
            route: 'q-project-settings-path'
        },
        //{
        //    key: 'summary',
        //    label: 'Summary',
        //    route: 'q-project-summary-path'
        //},
        //{
        //    key: 'phases',
        //    label: 'Phases',
        //    route: 'q-project-phases-path'
        //},
        {
            key: 'revenues',
            label: 'Revenues',
            route: 'q-project-revenues-path'
        },
        {
            key: 'resources',
            label: 'Resources',
            route: 'q-project-resource-allocations-path'
        },
        {
            key: 'expenses',
            label: 'Expenses',
            route: 'q-project-expense-allocations-path'
        },
        {
            key: 'capex',
            label: 'Capex',
            route: 'q-project-capex-path'
        },
        {
            key: 'pnl',
            label: 'P&L',
            route: 'q-project-pnl-path'
        },

    ])


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pages.value, (p) => {
        return (_openBlock(), _createElementBlock("li", {
          key: p.key,
          class: _normalizeClass(["nav-item", { active2: __props.ActivePage === p.key }])
        }, [
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: nav(p.route)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(p.label), 1 /* TEXT */)
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
        ], 2 /* CLASS */))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("hr", {
      class: "mt-0 mb-4",
      style: {"border-color":"#bbb"}
    }, null, -1 /* CACHED */))
  ]))
}
}

})